import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section eyebrow="FAQ" title="Frequently asked questions" data-id="element-142" data-mp="122n2ivu8i2hz">
      <ul className="mx-auto max-w-3xl space-y-3" data-id="element-143" data-mp="12352o3k0p0v6">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl border border-ink-line bg-white" data-id="element-144" data-mp="1urtxxlye6bz0" data-mpi={index}>
              <h3 data-id="element-145" data-mp="1g24j4nxdm9g9">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-146" data-mp="1g0jypr4s06w4">
                  <span className="text-[15px] font-bold leading-snug text-ink" data-id="element-147" data-mp="2dj37twc2r2r4">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-cyan-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-148" data-mp="2jre4r81ec0l9" />
                </button>
              </h3>
              {isOpen ? <p className="px-5 pb-5 text-[14.5px] leading-relaxed text-ink-soft" data-id="element-149" data-mp="37f5dk1nq9vhs">
                  {faq.answer}
                </p> : null}
            </li>;
      })}
      </ul>

      <TransformCTA label="I have no more doubts — I want the Renal Decision Desk™" sub="One-time $27 payment • Lifetime access • 7-day guarantee" data-id="element-150" data-mp="3he4q3vbm6ba2" />
    </Section>;
}